import React from "react";
import ChildMenuOptionOverlayLegacy from "shared-components/booking-options-section/ChildMenuOptionOverlay/index";
import ChildMenuOptionOverlay from "external-components/booking-options-section/ChildMenuOptionOverlay/index";
import {
  IDispatchFromProps,
  IOwnProps,
  IStateFromProps
} from "shared-components/booking-options-section/ChildMenuOptionOverlay/types";
import MenuOptionReducerService from "app/fakeReducer/menuOption.reducer";
import AppThemeService from "app/services/theme/appTheme.service";
import {wrapperStyleType} from "shared-types/WidgetTypes";
import {MenuOptionsState} from "external-components/booking-options-section/ChildMenuOptionOverlay/types";
import store from "appRoot/Store";
import ReactUtilsService from "app/services/reactUtils.service";
import { cloneDeep } from "lodash-es";
import {useSelector} from "react-redux";
import {BookingCreatorState} from "booking-creator/rootReducer";
import {DiaryRootState} from "appRoot/rootReducer";

const NS = 'ChildMenuOptionOverlayContainer';

/**
 * This container component cannot be declared within AngularJS HTML partials.
 * It can only be declared as a React (JSX) component and all AngularJS dependencies
 * must be injected into MenuOptionReducerService (see setup.controller.js).
 */

export default function ChildMenuOptionOverlayContainer({selectionData, handleClose, gridGutter, stateType, handleDone}: IOwnProps & IDispatchFromProps) {

  let menuOptionsImplicit: any;
  let menuOptionsExplicit: any;

  //prettier-ignore
  const activeChildMenuOption = useSelector((state: BookingCreatorState) => state.bookingOptionsUpsellReducer.activeChildMenuOption);
  let currency = useSelector((state: DiaryRootState) => state.venueReducer.currency);

  if (stateType === MenuOptionsState.DiaryLegacyState) {
    // this is for legacy EditBooking/NewBooking controller
    const legacyState = MenuOptionReducerService.getState();
    currency = legacyState.currency;
    menuOptionsImplicit = legacyState.activeChildMenuOption ? legacyState.activeChildMenuOption.menuOptionsImplicit : null;
    menuOptionsExplicit = legacyState.activeChildMenuOption ? legacyState.activeChildMenuOption.menuOptionsExplicit : null;
  } else if (activeChildMenuOption) {
    // This is for Booking Creator
    const mutatedMenuOptionsExplicit = activeChildMenuOption?.menuOptionsExplicit
      ? cloneDeep(activeChildMenuOption.menuOptionsExplicit)
      : undefined;
    const mutatedMenuOptionsImplicit = activeChildMenuOption?.menuOptionsImplicit
      ? cloneDeep(activeChildMenuOption.menuOptionsImplicit)
      : undefined;

    menuOptionsImplicit = activeChildMenuOption ? mutatedMenuOptionsImplicit : null;
    menuOptionsExplicit = activeChildMenuOption ? mutatedMenuOptionsExplicit : null;
  }


  const props: IStateFromProps = {
    wrapperStyle: wrapperStyleType.standard,
    theme: AppThemeService.getAppThemeAsWidgetTheme(),
    currency,
    isUpsell: false,
    menuOptionsImplicit,
    menuOptionsExplicit
  }

  const ownProps: IOwnProps = {
    selectionData, handleClose, gridGutter, stateType
  }

  return ReactUtilsService.containerWrap(
    stateType === MenuOptionsState.DiaryLegacyState
      ? <ChildMenuOptionOverlayLegacy {...props} {...ownProps} handleDone={handleDone} />
      : <ChildMenuOptionOverlay {...props} {...ownProps} handleDone={handleDone} isWideVersion={true} />
  );
}
